var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSauce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25629_5265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4807 10.4214C32.4487 7.97792 30.4575 6 28.0144 6C25.8318 6 24.011 7.57913 23.6245 9.65834C22.8572 9.99896 21.5244 10.5437 20.7302 10.6763C19.7727 10.836 18.6155 10.884 17.2908 10.8187C14.7605 10.694 12.2344 9.86735 9.98535 8.42748C7.15527 6.61593 4.74487 6.192 2.16968 7.05292C1.1709 7.38688 0.5 8.32963 0.5 9.3993C0.5 9.74584 0.687744 10.0648 0.989502 10.2306C1.33447 10.4199 1.65698 10.5836 1.96899 10.7416C3.65918 11.5981 4.59033 12.0698 5.20727 14.6696C5.66821 16.6108 6.47461 18.2379 7.60449 19.5055C8.08398 20.0436 8.62304 20.5183 9.21655 20.9269H22.0471C23.9853 19.4666 25.1719 17.2513 25.498 14.4583C25.6938 12.7816 25.5293 11.3198 25.4145 10.5994C25.4194 10.5607 25.4226 10.5215 25.4226 10.4813C25.4226 9.054 26.5852 7.89288 28.0144 7.89288C29.4433 7.89288 30.6062 9.054 30.6062 10.4813C30.6062 10.5264 30.6094 10.5715 30.6157 10.6161C30.6169 10.6255 30.7204 11.564 30.1423 12.2376C29.6684 12.7897 28.8313 13.0697 27.6543 13.0697C27.1365 13.0697 26.7168 13.4934 26.7168 14.0162C26.7168 14.5387 27.1365 14.9626 27.6543 14.9626C29.3996 14.9626 30.7136 14.4628 31.5593 13.4769C32.5967 12.2682 32.5205 10.7988 32.4807 10.4214Z",
    fill: "#FF7010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22168 22.8193C9.16943 23.0232 9.14185 23.2369 9.14185 23.4567V25.0533C9.14185 25.5758 9.56152 25.9998 10.0791 25.9998H21.2441C21.7617 25.9998 22.1816 25.5758 22.1816 25.0533V23.4567C22.1816 23.2369 22.1538 23.0232 22.1016 22.8193H9.22168Z",
    fill: "#FF7010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25629_5265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauce);
export default __webpack_public_path__ + "static/media/Sauce.ecd48eaa974026a1374049dfbf4d9c69.svg";
export { ForwardRef as ReactComponent };